export enum CarePlanRoutes {
  OVERVIEW = 'carePlanOverview',
  ACTIVITY = 'carePlanActivity',
  INTRO = 'carePlanIntro',
  END = 'carePlanEnd',
}
